export default __webpack_public_path__ + "static/media/40251.749b90d0.png";